module.exports = __webpack_public_path__ + "static/media/img94_R.32d1386b.jpg";